import { render, staticRenderFns } from "./LancamentoCardapio.vue?vue&type=template&id=33f4c80b&scoped=true&"
import script from "./LancamentoCardapio.vue?vue&type=script&lang=js&"
export * from "./LancamentoCardapio.vue?vue&type=script&lang=js&"
import style0 from "./LancamentoCardapio.vue?vue&type=style&index=0&id=33f4c80b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4c80b",
  null
  
)

export default component.exports